module.exports = __webpack_public_path__ + "img/sign-82.4b8e8731.jpg";